import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Container, Label, Input, InputGroup, Button, UncontrolledAlert, Form,} from "reactstrap";
import axios from "axios";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";

const AddUser = () => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken"); // Retrieve token as a plain string

  // State management for form data, errors, and success messages
  const [newUser, setNewUser] = useState({
    username: "",
    phone: "",
    email: "",
    password: "",
    confPassword: "",
    role: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");  

  // Handle input changes for text fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value });
  };

  // Handle file upload with validation
  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   // Validate file type
  //   if (
  //     ![
  //       "application/pdf",
  //       "application/msword",
  //       "application/docx",
  //       "image/jpeg",
  //       "image/jpg",
  //       "image/png",
  //       "plain/txt",
  //       "application/txt",
  //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     ].includes(file.type)
  //   ) {
  //     setError("Please upload a valid file (PDF or DOC/DOCX).");
  //     return;
  //   }

  //   // Validate file size (5MB limit)
  //   if (file.size > 200 * 1024 * 1024) {
  //     setError("File size exceeds the maximum allowed limit of 5MB.");
  //     return;
  //   }

  //   setNewUser({ ...newUser, file });
  // };

  // Validate form fields before submission
  const validateForm = () => {
    let isValidForm = true;
  
    // Check required fields
    const requiredFields = [
      "username",
      "phone",
      "email",
      "password",
      "confPassword",
      "role",
    ];
  
    for (let key of requiredFields) {
      if (!newUser[key]) {
        setError(`Please fill in the ${key.replace("_", " ")} field.`);
        isValidForm = false;
        break;
      }
    }
  
    // No additional date validation needed as Flatpickr ensures valid dates  
    if (isValidForm) setError(""); // Clear error if form is valid
    return isValidForm;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const apiUrl = process.env.REACT_APP_API_BASE_URL;

      // Create FormData object for file upload
      const formData = new FormData();
      Object.keys(newUser).forEach((key) => {
        // if (key === "file" && newUser[key]) {
        //   formData.append(key, newUser[key]);
        // } else 
        if (newUser[key]) {
          formData.append(key, newUser[key]);
        }
      });

      // Send request to server
      const response = await axios.post(
        `${apiUrl}/api/createUser`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            "Authorization": `Bearer ${token}`, // Use token directly
          },
        }
      );

      if (response.status < 200 || response.status >= 300) {
        throw new Error("Failed to create user");
      }

      setSuccess("User created successfully!");
      setError(""); // Clear any existing error message

      setTimeout(() => {
        setSuccess("");
        setNewUser({
          username: "",
          phone: "",
          email: "",
          password: "",
          confPassword: "",
          role: "",
        });
        navigate("/user"); // Redirect to users page
      }, 2000);
    } catch (error) {
      console.error("Error creating user:", error);

      let errorMessage = "An unexpected error occurred.";
      if (error.response) {
        errorMessage = error.response.data?.message || error.response.statusText;
      } else if (error.request) {
        errorMessage = "No response from server.";
      } else {
        errorMessage = error.message;
      }

      setError(errorMessage);
    }
  };

  // Render input fields dynamically
  const renderInputField = (key) => {
    switch (key) {
      case "effective_from":
  
      // case "file":
      //   return (
      //     <Input
      //       type="file"
      //       name="file"
      //       id="file"
      //       onChange={handleFileChange}
      //     />
      //   );
  
      case "role":
        return (
          <Input
            type="select"
            name="role"
            value={newUser.role}
            onChange={handleChange}
          >
            <option value="">Select Role</option>
            <option value="IT">IT</option>
            <option value="legal">Legal</option>
            <option value="director">Director</option>
          </Input>
        );
  
      default:
        return (
          <Input
            type="text"
            name={key}
            value={newUser[key]}
            onChange={handleChange}
          />
        );
    }
  };

  // Define form fields
  const formFields = [
    "username",
    "phone",
    "email",
    "password",
    "confPassword",
    "role",
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Forms" breadcrumbItem="Add New User" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  {error && <UncontrolledAlert color="danger">{error}</UncontrolledAlert>}
                  {success && <UncontrolledAlert color="success">{success}</UncontrolledAlert>}
                  <Form onSubmit={handleSubmit}>
                    {formFields.map((key) => (
                      <>
                      <Row className="mb-3" key={key}>
                        <Label htmlFor={key} className="col-md-2 col-form-label" id={`label-${key}`}>
                          {key
                            .replace("_", " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase())}
                        </Label>
                        <div className="col-md-10">{renderInputField(key)}</div>
                      </Row>
                    </>                    
                    ))}
                    <Button color="primary" type="submit">
                      Add User
                    </Button>
                    <Button color="secondary" tag={Link} to="/user" className="ms-2">
                      Cancel
                    </Button>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddUser;